'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Option as BaseOption } from "@mui/base/Option";
import { cva } from "class-variance-authority";
import { cn } from "../../common/helpers.js";
export const optionClasses = cva([
    'hover:cursor-pointer',
    'px-4',
    'py-2',
    'focus:outline-none',
    'first:rounded-t-lg',
    'last:rounded-b-lg'
], {
    variants: {
        selected: {
            true: [
                'bg-primary-50'
            ],
            false: [
                'focus:bg-gray-75'
            ]
        },
        disabled: {
            true: [
                'text-black/40'
            ],
            false: [
                'hover:bg-gray-75'
            ]
        }
    }
});
/**
 * Select Option - [API](https://scl.sharp.com/?path=/docs/base-select) | [DSM](https://sharphealthcare.notion.site/Inputs-4a77e695a529479fa701e2f3dcdc47e7#49e2612563204c958d34ed4ef4ee92aa)
 *
 * This component is meant to be nested inside of `<Select />`.
 */ const SelectOption = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { className } = _param, props = _object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(BaseOption, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        slotProps: {
            root: ({ selected, disabled })=>({
                    className: cn(optionClasses({
                        selected,
                        disabled,
                        className
                    }))
                })
        }
    }));
});
export { SelectOption };
